module.exports = __webpack_public_path__ + "img/blank-default.0bdd71b1.png";